var map = {
	"./banner-1.jpg": "yKC3",
	"./banner-2.jpg": "ojX4",
	"./banner-3.jpg": "Wz/j",
	"./beijing-bg.jpg": "jnn0",
	"./chengdou-bg.jpg": "BnFI",
	"./mission-bg.jpg": "zugS",
	"./mission-new-1.jpg": "IjuI",
	"./mission-new-2.jpg": "tkWr",
	"./work-idea-bg.jpg": "EWee",
	"./work-idea-img1.jpg": "L8aQ",
	"./work-idea-img2.jpg": "7/Pq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XEJ1";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce ^\.\/.*\.jpg$
// module id = XEJ1
// module chunks = 1